
export default {
    name: "popup_bonus_code",
    data(){
        return {
            isLoading: false,
            isSubmitted: false,

            code: null,
            points: 0,
        }
    },
    computed: {
        
    },
    mounted(){

    },
    methods: {
        onClickSubmitBtn(){
            if(!this.code) return;

            if(!this.isLoading){
                this.isLoading = true;

                this.onHandleTriggerAnalytics(`submit@bonus_code`);

                this.$axios.$post("/bonus_code", { code: this.code }, this.tokenHeader).then((res) => {
                    console.log("submitBonusCodeCallback", res);

                    this.points = res.stamp?.point || 0;
                    if(res.stamp) this.$store.commit("stamp/addItem", res.stamp);
                }).catch(err => {
                    console.error("submitBonusCodeError", err);
                    this.points = 0;
                    // return this.onHandleApiError(err);
                }).finally(() => {
                    this.code = null;
                    this.isLoading = false;
                    this.isSubmitted = true;
                });
            }
        },
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@bonus_code`);
        },
    },
    watch: {
        
    }
}
